/* eslint-disable @typescript-eslint/member-delimiter-style */
/* eslint-disable no-unneeded-ternary */
/* eslint-disable import/no-extraneous-dependencies */

'use client'

import React, { useMemo } from 'react'
import styled from 'styled-components'

const BreadContainer = styled.div<{ pad?; mPad? }>`
  padding: ${props => props.pad || '0.938rem 0 2rem'};
  box-sizing: border-box;
  @media (max-width: 700px) {
    padding: ${props => props.mPad || '0.938rem 1.25rem 1.125rem'};
  }
`
const BreadText = styled.div`
  font-size: 0.75rem;
  color: rgb(51, 51, 51);
`

const BreadLinkTag = styled.a`
  text-decoration: none;
  color: rgb(51, 51, 51);
`
const NotLinkTag = styled.span``

const AckodriveBreadCrumb = props => {
  const { post, pad, mPad, itemType, itemId, breadCrumbObj } = props

  const defaultBreadcrumb = useMemo(
    () => [
      {
        value: 'Home',
        url: '/',
      },
      {
        value: itemType,
        url: `/${itemId}/`,
      },
      {
        value: post?.attributes?.title || post?.attributes?.articleTitle,
        url: null,
      },
    ],
    [post, itemType, itemId]
  )

  const breadcrumb = breadCrumbObj || defaultBreadcrumb

  return (
    <BreadContainer id="breadCrumb" pad={pad} mPad={mPad}>
      <BreadText>
        {breadcrumb.map((item, index) => (
          <React.Fragment key={index}>
            {item.url ? <BreadLinkTag href={item.url}>{item.value}</BreadLinkTag> : <NotLinkTag>{item.value}</NotLinkTag>}
            {index !== breadcrumb.length - 1 ? <NotLinkTag> / </NotLinkTag> : null}
          </React.Fragment>
        ))}
      </BreadText>
    </BreadContainer>
  )
}

export default AckodriveBreadCrumb
